// Films shown for a limited time (assets/videos/films.json; Seán, 2026-11-05): not in our Vimeo
// library, so added to the gallery's showcases by hand, at /Videos/<path> (Video/Film.vue). The
// preview's thumbnail stands in for the film's, and its description (with the bio) follows the
// film's intro, the acknowledgement last. Who may watch, and when: the fullstack (api/v1/videos/film/<key>).
import films from "@/assets/videos/films.json";

export const FILM_PATHS = Object.keys(films);
export const getFilm = (path) => films[path];

// the film's path for a program row (films.json "program": its speaker, in rows from a date on,
// e.g. Martin Dohrn's November talk), once listed; "" otherwise (Seán, 2026-11-05)
function getIsFilmRow({program}, speakerNames, startMillis) {
  if (!program || !speakerNames.includes(program.speaker)) return false;
  return startMillis >= Date.parse(program.from);
}

export function getProgramFilmPath(speakerNames, startMillis, getIsListed) {
  const entry = Object.entries(films).find(([, film]) =>
    getIsListed(film.key) && getIsFilmRow(film, speakerNames, startMillis));
  return entry ? `/Videos/${entry[0]}` : "";
}

function getFilmVideo(film, preview) {
  const texts = [film.intro, preview?.description, film.acknowledgement];
  const description = texts.filter(Boolean).join("\n\n");
  const {name, tag, privacy, duration} = film;
  return {name, tag, privacy, duration, description, pictures: preview?.pictures};
}

// first in its showcase: a keynote, and the gallery's order (useVizbiOrder) keeps the order within
// a tag, so it leads the other keynotes (Seán, 2026-11-05). Always there; the Program page's bird
// (getIsListed(key), composables/useFilmListings.js) decides where its card goes: on, the film's
// page; off, the preview's (linkTo, GalleryItem.vue), as the preview, a duplicate of its card
export function addFilms(showcases, getIsListed) {
  for (const [path, film] of Object.entries(films)) {
    const showcase = showcases?.[film.showcase];
    if (!showcase?.videos) continue;
    const filmVideo = getFilmVideo(film, showcase.videos[film.preview]);
    const card = getIsListed(film.key) ? filmVideo : {...filmVideo, linkTo: film.preview};
    showcase.videos = {[path]: card, ...showcase.videos};
  }
  return showcases;
}
